import React from 'react';
import { PersonalInfoMain } from '../../../ProfileOPL/PersonalInfo/PersonalInfo';
import { PersonalInfoContext } from '../../../ProfileOPL/PersonalInfo/PersonalInfo.meta';
import { StepContainer } from './components/StepContainer/StepContainer';

interface Props {
  onNextStage(): void;
}

export const PersonalInfo = ({ onNextStage }: Props) => {
  return (
    <StepContainer>
      <PersonalInfoMain
        context={PersonalInfoContext.CharitableGivingWorkflow}
        onSuccess={onNextStage}
      />
    </StepContainer>
  );
};
